// import { data } from "../pages/ListPlans/ListPlans.model";
import { http } from "./api";

export const plan = {
    create: async (data) => {
        try {
            const response = await http.post("v1/plans/", data);

            if (response.success && response.requestCode === 201) {
                return {
                    success: true,
                    message: "Plan creado correctamente",
                    requestCode: response.requestCode,
                };
            }

            return {
                success: false,
                message: "Error al crear el plan",
                requestCode: response.requestCode,
            };
        } catch (error) {
            console.error("Error al crear el plan:", error);
            return {
                success: false,
                message:
                    "Error al crear el plan. Por favor, inténtalo más tarde.",
                requestCode: 500,
            };
        }
    },

    get: async () => {
        try {
            const response = await http.get("v1/plans/");

            if (response.success && response.requestCode === 200) {
                return response;
            }

            return {
                success: false,
                message: "Error al obtener los planes",
                requestCode: response.requestCode,
            };
        } catch (error) {
            console.error("Error al obtener los planes:", error);
            return {
                success: false,
                message:
                    "Error al obtener los planes. Por favor, inténtalo más tarde.",
                requestCode: 500,
            };
        }
    },
};